$(document).ready(function(){
  const firstImage = $('.specifications__images-list li').first().attr('data-src');
  $('.specifications__placeholder-image').attr('src',firstImage);

  $('.specifications__images-list li a').hover(function(){
     let currentImage = $(this).parent('li').attr('data-src');
     $('.specifications__placeholder-image').attr('src',currentImage);
  });

  $("a.features__option").on("click",function(){
     const content = $(this).attr('data-html');
     const options ={
       helpers:{
         overlay: {
          opacity: 0.8,
          css: {'background-color': '#FF0000'}
         }         
       }
     };
     $.fancybox.open(content,options);
  });

  $("a.key-feature").on("click",function(){
     const content = $(this).attr('data-html');
     const options ={
       helpers:{
         overlay: {
          opacity: 0.8,
          css: {'background-color': '#FF0000'}
         }         
       }
     };
     $.fancybox.open(content,options);
  })  
})

